export { default } from './SiteNavDesktopShopMenu';
